// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgContactList24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M5.5 4.5V15.5H12V17H5C4.44772 17 4 16.5523 4 16V4C4 3.44772 4.44772 3 5 3H16C16.5523 3 17 3.44772 17 4V10H15.5V4.5H5.5ZM13.5 8H7.5V6.5H13.5V8ZM13.5 11H7.5V9.5H13.5V11ZM14.9387 16.5813C13.4538 16.5813 12.25 17.7851 12.25 19.27V20.2393C12.25 20.6535 12.5858 20.9893 13 20.9893H20.27C20.6842 20.9893 21.02 20.6535 21.02 20.2393V19.27C21.02 17.7851 19.8162 16.5813 18.3313 16.5813H14.9387ZM13.75 19.27C13.75 18.6135 14.2822 18.0813 14.9387 18.0813H18.3313C18.9878 18.0813 19.52 18.6135 19.52 19.27V19.4893H13.75V19.27ZM16.75 12.75C16.1977 12.75 15.75 13.1977 15.75 13.75C15.75 14.3023 16.1977 14.75 16.75 14.75C17.3023 14.75 17.75 14.3023 17.75 13.75C17.75 13.1977 17.3023 12.75 16.75 12.75ZM14.25 13.75C14.25 12.3693 15.3693 11.25 16.75 11.25C18.1307 11.25 19.25 12.3693 19.25 13.75C19.25 15.1307 18.1307 16.25 16.75 16.25C15.3693 16.25 14.25 15.1307 14.25 13.75Z"
				/>
			</Svg>
		);
	}
);
SvgContactList24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgContactList24;
